import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { Observable } from "rxjs";
import { endpointsURL } from "src/app/constants/endpointsURL";
import {ValidateVehiculo} from "../../certificates/models";
// import { IResponsesPageables } from "../core/models/responesPageables";

@Injectable({
  providedIn: "root",
})
export class SolicitudPlacaService {
  env = environment.env;
  placaMailBoxURL = endpointsURL.placaURL;
  requestURL = endpointsURL.requestURL;
  constructor(private httpClient: HttpClient) {}

  public getPlacaMailBoxList(filters: string): Observable<any> {
    return this.httpClient.get<any>(
      `${this.env}${this.placaMailBoxURL}${filters}`
    );
  }

  public getFile(type: string) {
    let params = new HttpParams().set("_tipoPlantilla", type);
    return this.httpClient.put(
      `${this.env}${this.requestURL}/Placa/descargaPlantilla`,
      {},
      {
        responseType: "blob",
        params: params,
      }
    );
  }

  public individual(datosGroupForm: any, file: any): Observable<any> {
    const fd = new FormData();

    fd.append("_file1", file.data, file.name);

    let maintenancePeticionesDto = {
      detallePeticionesDto: [{ dpCampoid: "Individual", dpFichero: file.name }],
      peticionesDto: {
        peBastidor: datosGroupForm.value.bastidor,
        peModelo: datosGroupForm.value.modelo,
        peTMotor: datosGroupForm.value.tipoMotor,
        peTCambio: datosGroupForm.value.tipoCambio,
        peNumPuertas: datosGroupForm.value.numPuertas,
        peMotivoReedicion: datosGroupForm.value.motivoReedicion,
        peTipoPlaca: datosGroupForm.value.tipoPlaca,
        peObservaciones: datosGroupForm.value.observaciones,
        peCertificadoPlaca: "PL",
      },
    };

    fd.append(
      "_maintenancePeticionesDto",
      JSON.stringify(maintenancePeticionesDto)
    );

    return this.httpClient.put<any>(
      `${this.env}${this.requestURL}/Placa/individual`,
      fd
    );
  }

  public homologador(datosGroupForm: any, file: any): Observable<String[]> {
    const fd = new FormData();
    fd.append("_file1_excel", file.data, file.name);
    let maintenancePeticionesDto = {
      peticionesDto: {
        peCertificadoPlaca: "PLH",
        peSoloFacturar: datosGroupForm.value.facturar,
      },
      detallePeticionesDto: [
        { dpCampoid: "Homologador", dpFichero: file.name },
      ],
    };

    fd.append(
      "_maintenancePeticionesDto",
      JSON.stringify(maintenancePeticionesDto)
    );
    return this.httpClient.put<String[]>(
      `${this.env}${this.requestURL}/Placa/masivaHomologador`,
      fd
    );
  }

  public importador(file: any): Observable<String[]> {
    const fd = new FormData();
    fd.append("_file1_excel", file.data, file.name);
    let maintenancePeticionesDto = {
      peticionesDto: {
        peCertificadoPlaca: "PLI",
      },
      detallePeticionesDto: [{ dpCampoid: "Importador", dpFichero: file.name }],
    };

    fd.append(
      "_maintenancePeticionesDto",
      JSON.stringify(maintenancePeticionesDto)
    );
    return this.httpClient.put<String[]>(
      `${this.env}${this.requestURL}/Placa/masivaImportador`,
      fd
    );
  }

  public validateVehiculoBastidor(dto: ValidateVehiculo): Observable<any> {
    return this.httpClient.post<any>(
      `${this.env}${this.requestURL}/certificado/validacion/bastidor`,
      dto
    );
  }
}
